import React from 'react';
import { Caption } from '~/shared/Typography';
import { Pressable, HStack } from 'native-base';
import { useTheme } from '@springbig/shared';

export type TabSelectorProps = {
    tabs: Array<{
        name: string;
        action?: () => void;
        isSelected?: boolean;
    }>;
};

export const TabSelector = ({ tabs }: TabSelectorProps) => {

    const {
        button_primary,
        button_text,
        radius_sm,
    } = useTheme();

    return (
        <HStack justifyContent={'center'}>
            { tabs.map((tab, index) => {

                return (
                    <Pressable
                        key={index}
                        onPress={tab.action}
                        bg={tab.isSelected ? button_primary : button_text}
                        borderColor={button_primary}
                        borderWidth={1}
                        borderRightWidth={tab.isSelected && index === 0 ? 0 : 1}
                        borderLeftWidth={tab.isSelected && index > 1 ? 0 : 1}
                        py={1}
                        mr={index === 0 ? -3 : 0}
                        pr={index === 0 && tab.isSelected ? 7 : 5}
                        ml={index > 1 ? -3 : 0}
                        pl={index > 1 && tab.isSelected  ? 7 : 5}
                        zIndex={tab.isSelected ? 0 : -1}
                        rounded={radius_sm}
                    >
                        <Caption
                            color={tab.isSelected ? button_text : button_primary}
                        >
                            { tab.name }
                        </Caption>
                    </Pressable>
                );
            })}
        </HStack>
    );
};
